import BaseManager from "@base/manager/BaseManager";
import Facade from "@/Facade";
import GameStatesEnum from "@/states/GameStatesEnum";
import { Signals } from "@/Imports";
import { UIBehaviors } from "../ui/UIBehaviors";

export default class AutoplayManager extends BaseManager {
  constructor(data) {
    super(data);
    this.isAutoplay = false;
    this.init();
  }

  init() {
    this.totalAutoSpins = -1;
    this.addListeners();
  }

  addListeners() {
    Signals.stateChanged.add(this.onStateChanged, this);
    Signals.setAutoplay.add(this.onSetAutoplay, this);
    Signals.stopAutoplay.add(this.onStopAutoplay, this);
    Signals.outroFreespinsComplete.add(this.onShowFreespinsOutroComplete, this);
    Signals.showBonusOutroComplete.add(this.onShowBonusOutroComplete, this);
  }

  onShowFreespinsOutroComplete() {
    if (this.isAutoplay) {
      this.startAutoplay();
    }
  }
  onShowBonusOutroComplete() {
    if (this.isAutoplay && !Facade.model.isFreespinsMode) {
      this.startAutoplay();
    }
  }

  onStopAutoplay(isDirty) {
    if (isDirty) {
      this.reset();
    }
    Facade.model.isAuto = false;
    //Signals.autospinCountChanged.dispatch(this.totalAutoSpins)
  }

  onSetAutoplay(_) {
    this.data = _;
    this.startAutoplay();
  }

  startAutoplay() {
    this.isAutoplay = true;
    Facade.model.isAuto = true;
    if (
      Facade.model.stateMachine.currentStateName === GameStatesEnum.IDLE ||
      Facade.model.stateMachine.currentStateName ===
        GameStatesEnum.SHOW_CYCLEWINNINGS
    ) {
      Signals.autospinCountChanged.dispatch(this.totalAutoSpins);
      Signals.spinBtnPressed.dispatch();
    }
  }

  set data(_) {
    this.snapBalance = Facade.model.balance;
    this.totalAutoSpins = _.value;
    //   this.singleWin = _.singleWin !== -1 ? _.singleWin : 0
    this.cashIncrease = _.cashIncrease !== -1 ? _.cashIncrease : 0;
    this.cashDecrease = _.cashDecrease !== -1 ? _.cashDecrease : 0;
    this.whenEnteringFreeSpins = _.whenEnteringFreeSpins;
  }

  onStateChanged(_) {
    if (Facade.model.isFreespinsMode || !Facade.model.isAuto) {
      return;
    }
    switch (_) {
      case GameStatesEnum.SPIN_START:
        console.log("AUTO SPIN");
        if (this.totalAutoSpins != -1 && !Facade.model.isFreespinsMode) {
          this.totalAutoSpins--;
          if (Facade.model.isAuto && this.totalAutoSpins > 0) {
            let enableUIDelayT = this.getEnableUIDelay();
            if (enableUIDelayT > 0) {
              setTimeout(() => {
                Signals.autospinCountChanged.dispatch(this.totalAutoSpins);
              }, enableUIDelayT);
            } else {
              Signals.autospinCountChanged.dispatch(this.totalAutoSpins);
            }
          } else {
            //Signals.autospinCountChanged.dispatch (0)
            Signals.autoplayFinished.dispatch();
            this.reset();
          }
        }
        break;

      case GameStatesEnum.SPIN_STOP:
        // if(this.singleWin > 0 && Facade.model.totalWin >= this.singleWin * Facade.model.totalBet) {
        //   this.reset()
        // }

        if (this.whenEnteringFreeSpins && Facade.model.countAmountFreeBet > 0) {
          this.reset();
        }

        if (
          this.cashIncrease > 0 &&
          Facade.model.balance - this.snapBalance >=
            this.cashIncrease * Facade.model.totalBet
        ) {
          this.reset();
        }

        if (
          this.cashDecrease > 0 &&
          this.snapBalance - Facade.model.balance >=
            this.cashDecrease * Facade.model.totalBet
        ) {
          this.reset();
        }
        break;
      default:
        break;
    }
  }

  reset() {
    this.singleWin = 0;
    this.cashDecrease = 0;
    this.cashIncrease = 0;
    this.whenEnteringFreeSpins = false;
    this.isAutoplay = false;
    Facade.model.isAuto = false;
    this.totalAutoSpins = 0;
    Signals.autoplayFinished.dispatch();
  }
  getEnableUIDelay() {
    return !Facade.model.lastSpinTime
      ? 0
      : Math.max(
          0,
          Facade.model.minIntervalSpin -
            (new Date().getTime() - Facade.model.lastSpinTime.getTime())
        );
  }
}
